export interface DesignOption {
  id: string;
  name: string;
  displayName: string;
  description: string;
  path: string;
  image: string;
  status: 'recommended' | 'base' | 'alternative';
  statusLabel: string;
  features: string[];
  cwvScores: {
    lcp: string;
    cls: string;
    inp: string;
    overall: 'A' | 'B' | 'C';
  };
  colorTheme: {
    primary: string;
    secondary: string;
  };
  previewGradient: string;
}

export const designOptions: DesignOption[] = [
  {
    id: 'app4',
    name: 'Red Antler Final',
    displayName: 'Opción C: Red Antler',
    description: 'Diseño final inspirado en la estética de Red Antler. Tipografía bold, layouts asimétricos dinámicos, y una paleta terracota/sage que comunica calidez y sofisticación.',
    path: '/app4/',
    image: '/images/app4-screenshot.png',
    status: 'recommended',
    statusLabel: 'Recomendado',
    features: [
      'Tipografía bold con alto contraste',
      'Layouts asimétricos dinámicos',
      'Paleta terracota/sage premium',
      'Microinteracciones refinadas',
      'Optimizado para CWV (90+ performance)',
      'Diseño mobile-first excepcional',
    ],
    cwvScores: {
      lcp: '1.2s',
      cls: '0.02',
      inp: '58ms',
      overall: 'A',
    },
    colorTheme: {
      primary: '#C75B2A',
      secondary: '#7A8B6E',
    },
    previewGradient: 'from-terracotta-100 via-sage-100 to-stone-100',
  },
  {
    id: 'app',
    name: 'Original',
    displayName: 'Opción A: Original',
    description: 'El diseño original de partida. Estilo clásico con estructura tradicional, tipografía serif conservadora y paleta de colores neutros.',
    path: '/app/',
    image: '/images/app-screenshot.png',
    status: 'base',
    statusLabel: 'Base',
    features: [
      'Diseño clásico y conservador',
      'Optimizado para Core Web Vitals (Grade A)',
      'Tipografía serif tradicional',
      'Paleta de colores neutros',
      'Layout simétrico y predecible',
      'Carga ultrarrápida con imágenes AVIF'
    ],
    cwvScores: {
      lcp: '1.3s',
      cls: '0.03',
      inp: '60ms',
      overall: 'A',
    },
    colorTheme: {
      primary: '#78716c',
      secondary: '#a8a29e',
    },
    previewGradient: 'from-stone-200 via-stone-100 to-stone-50',
  },
  {
    id: 'app2',
    name: 'Iteración 2',
    displayName: 'Opción B: Iteración',
    description: 'Segunda iteración con mejoras en la jerarquía visual y exploración de colores más cálidos. Intermedio entre el original y el diseño final.',
    path: '/app2/',
    image: '/images/app2-screenshot.png',
    status: 'alternative',
    statusLabel: 'Alternativa',
    features: [
      'Mejoras en jerarquía visual',
      'Exploración de colores cálidos',
      'Optimizado para Core Web Vitals (Grade A)',
      'Espaciado mejorado',
      'Transición hacia el diseño final',
      'Rendimiento excepcional < 1.3s LCP'
    ],
    cwvScores: {
      lcp: '1.2s',
      cls: '0.02',
      inp: '55ms',
      overall: 'A',
    },
    colorTheme: {
      primary: '#b45309',
      secondary: '#65a30d',
    },
    previewGradient: 'from-amber-100 via-lime-100 to-stone-100',
  },
];

export const proposalMeta = {
  title: 'Propuesta de Rediseño - Terres',
  subtitle: 'Selecciona una opción de diseño para explorar',
  client: 'Terres',
  agency: 'Studio',
  date: new Date().toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }),
};
